import React, { useEffect, useRef, useState } from "react";
import { Card, Col, Row, Typography, Form, Input, Button, Checkbox, Select, Rate, Modal, Popover, Collapse, } from "antd";
import { FaChevronDown, FaChevronUp, FaInfoCircle, FaMapMarkedAlt, FaRegEnvelope } from "react-icons/fa";
import { useLocation, Link } from "react-router-dom";
import moment from "moment";
import { gethotelbook } from "../../../services/hotel/hotelServices";
import { flightLoader } from "../../../utils/ImagePath";
import CancellationPolicyHotel from "../PaymentHotelpage/CancellationPolicyHotel";
import { formatDate } from "../../../utils/Constants";
import HotelOffers from "../PaymentHotelpage/HotelOffers";
import HotelOffersMobile from "../PaymentHotelpage/HotelOffersMobile";
import FilteredInput from "../../../layout/FilteredInput";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import { InfoCircleOutlined, CaretRightOutlined } from "@ant-design/icons";

const { TextArea } = Input;
const { Title, Text } = Typography;
const { Panel } = Collapse;

const HotelPaymentTbo = ({ loading }) => {
  const [appliedCheckLogin, setAppliedCheckLogin] = useState("");
  const [isOtherDivActive, setOtherDivActive] = useState(false);
  const [bookingLoader, setBookingLoader] = useState(null);
  const [bookingMessage, setBookingMessage] = useState(null);
  const [bookingMessageError, setBookingMessageError] = useState(null);
  const [checked, setChecked] = useState(false);
  const location = useLocation();
  const [phoneValue, setPhoneValue] = useState('');
  const { selectedRoomData, isRedeem, hotelDetails, resultIndex } = location.state || {};
  const totalNights = JSON.parse(localStorage.getItem("night"));
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [roomInfo, setRoomInfo] = useState(null);

  useEffect(() => {
    const storedStartDate = localStorage.getItem("startDate");
    const storedEndDate = localStorage.getItem("endDate");
    const storedRoomInfo = localStorage.getItem("roomInfo");

    if (storedStartDate) {
      const formattedStartDate = moment(storedStartDate, [
        "MMM DD, YYYY",
        "YYYY-MM-DD",
      ]).format("YYYY-MM-DD");
      setStartDate(formattedStartDate);
    }

    if (storedEndDate) {
      const formattedEndDate = moment(storedEndDate, [
        "MMM DD, YYYY",
        "YYYY-MM-DD",
      ]).format("YYYY-MM-DD");
      setEndDate(formattedEndDate);
    }
    if (storedRoomInfo) setRoomInfo(JSON.parse(storedRoomInfo));
  }, []);

  const nights = parseInt(totalNights);
  const totalNOAdults = roomInfo?.reduce(
    (total, room) => total + room.numberOfAdults,
    0
  );

  const totalNOChildren = roomInfo?.reduce(
    (total, room) => total + room.numberOfChild,
    0
  );

  const totalRooms = roomInfo?.length;
  const [form] = Form.useForm();

  // let Total =
  //   nights * selectedRoomData?.Price?.PublishedPriceRoundedOff +
  //   nights * selectedRoomData?.Price?.ServiceTax -
  //   discountAmount;

  const [countryCode, setCountryCode] = useState(null)
  const validatePhone = (_, value) => {
    if (!value || value.trim() === "" || value === "+91") {
      return Promise.reject(new Error("Mobile number is required"));
    }
    const phoneNumber = parsePhoneNumberFromString(countryCode);
    if (!phoneNumber || !phoneNumber.isValid()) {
      return Promise.reject(new Error("Enter a valid mobile number"));
    }
    return Promise.resolve();
  };

  const handlePhoneChange = (value) => {
    setCountryCode(value)
    const sanitized = value.replace("+91", "").trim();
    setPhoneValue(sanitized);
    form.setFieldsValue({ contacts: sanitized });
  };

  let getUser = JSON.parse(localStorage.getItem("user"));
  let user_reward_points = getUser?.reward_point;

  const [applyDiscountShow, setApplyDiscountShow] = useState(false);
  const [isCongratulations, setIsCongratulations] = useState(null);
  const [isValidCoupon, setValidCoupon] = useState(null);
  const [couponId, setCouponId] = useState(null);

  const applyDiscount = () => {
    setCouponId(null);
    if (appliedCheckLogin.type === "CASHBACK_OFFER") {
      const totalAmount = Math.round(
        nights * selectedRoomData?.Price?.TotalPublishFare * totalRooms || 0
      );

      let discountAmountOffer = 0;
      let totalAfterDiscount = totalAmount;

      if (appliedCheckLogin?.discountType === "PERCENTAGE") {
        discountAmountOffer =
          (totalAmount * (appliedCheckLogin?.discount || 0)) / 100;
        if (discountAmountOffer < user_reward_points) {
          totalAfterDiscount = totalAmount - discountAmountOffer;
          setCouponId(appliedCheckLogin?.id);
          setApplyDiscountShow(true);
          setIsCongratulations(true);
          setValidCoupon(null);

          setDiscountAmountOffer(discountAmountOffer);
          setTotalAfterDiscount(totalAfterDiscount);
        }
        else {
          // alert('We’re sorry, but it seems your account balance is insufficient to redeem this coupon.')
          setApplyDiscountShow(false);
          setIsCongratulations(false);
          setCouponId(null);
          setValidCoupon(
            "We’re sorry, but it seems your account balance is insufficient to redeem this coupon."
          );
        }
      }
      else if (appliedCheckLogin?.discountType === "AMOUNT") {
        discountAmountOffer = appliedCheckLogin?.discount || 0;
        if (discountAmountOffer < user_reward_points) {
          totalAfterDiscount = totalAmount - discountAmountOffer;
          setCouponId(appliedCheckLogin?.id);
          setApplyDiscountShow(true);
          setIsCongratulations(true);
          setValidCoupon(null);

          setDiscountAmountOffer(discountAmountOffer);
          setTotalAfterDiscount(totalAfterDiscount);
        }
        else {
          setCouponId(null);
          setApplyDiscountShow(false);
          setIsCongratulations(false);
          setValidCoupon(null);
          setValidCoupon(
            "We’re sorry, but it seems your account balance is insufficient to redeem this coupon."
          );
        }
      }
    }
    else {
      const totalAmount = Math.round(
        nights * selectedRoomData?.Price?.TotalPublishFare * totalRooms || 0
      );

      let discountAmountOffer = 0;
      let totalAfterDiscount = totalAmount;

      if (appliedCheckLogin?.discountType === "PERCENTAGE") {
        discountAmountOffer =
          (totalAmount * (appliedCheckLogin?.discount || 0)) / 100;
        totalAfterDiscount = totalAmount - discountAmountOffer;
      }
      else if (appliedCheckLogin?.discountType === "AMOUNT") {
        discountAmountOffer = appliedCheckLogin?.discount || 0;
        totalAfterDiscount = totalAmount - discountAmountOffer;
      }
      setApplyDiscountShow(true);
      setIsCongratulations(true);
      setCouponId(appliedCheckLogin?.id);

      setDiscountAmountOffer(discountAmountOffer);
      setTotalAfterDiscount(totalAfterDiscount);
    }
  };

  const [discountAmountOffer, setDiscountAmountOffer] = useState(0);
  const [totalAfterDiscount, setTotalAfterDiscount] = useState(0);
  const [isFormValid, setIsFormValid] = useState(false);
  const [hasTriedSubmit, setHasTriedSubmit] = useState(false);

  const values = Form.useWatch([], form);

  useEffect(() => {
    const checkValidation = async () => {
      try {
        await form.validateFields();
        setIsFormValid(true);
      } catch {
        setIsFormValid(false);
      }
    };
    if (hasTriedSubmit || Object.values(values || {}).some((v) => v)) {
      checkValidation();
    }
  }, [values, form, hasTriedSubmit]);


  // const onFinishFailed = () => {
  //   setHasTriedSubmit(true);
  //   setTimeout(() => {
  //     const errorElements = document.querySelectorAll('.ant-form-item-has-error');
  //     if (errorElements.length > 0) {
  //       const firstError = errorElements[0];
  //       const elementRect = firstError.getBoundingClientRect();
  //       const absoluteElementTop = elementRect.top + window.pageYOffset;
  //       const offset = 120;
  //       const scrollToPosition = absoluteElementTop - offset;
  //       window.scrollTo({
  //         top: scrollToPosition,
  //         behavior: 'smooth'
  //       });
  //     }
  //   }, 100);
  // };

  const [activeKeys, setActiveKeys] = useState(["0"]); // which panels are open

  const onFinishFailed = () => {
    setTimeout(() => {
      const errorElements = document.querySelectorAll(".ant-form-item-has-error");

      if (errorElements.length > 0) {
        const firstError = errorElements[0];
        const collapsePanel = firstError.closest(".ant-collapse-item");

        // 1️⃣ Find the key of the collapse panel with the error
        if (collapsePanel) {
          const panelKey = collapsePanel.getAttribute("data-panel-key");

          // 2️⃣ Open the panel if it's closed
          if (panelKey && !activeKeys.includes(panelKey)) {
            setActiveKeys((prev) => [...prev, panelKey]);
          }
        }

        // 3️⃣ Smoothly scroll to the error field
        const elementRect = firstError.getBoundingClientRect();
        const absoluteElementTop = elementRect.top + window.pageYOffset;
        const offset = 120; // adjust if header present
        const scrollToPosition = absoluteElementTop - offset;

        window.scrollTo({
          top: scrollToPosition,
          behavior: "smooth",
        });
      }
    }, 100);
  };
  const onFinishBook = async (values) => {
    setHasTriedSubmit(true);
    setBookingLoader(true);
    const hotelPassengers = [];
    const prepareAdultPassengers = (room, roomIndex, values) => {
      return Array.from({ length: room?.numberOfAdults }).map(
        (_, adultIndex) => ({
          Title: values[`room-${roomIndex}-adult-${adultIndex}-title`],
          FirstName: values[`room-${roomIndex}-adult-${adultIndex}-firstName`],
          LastName: values[`room-${roomIndex}-adult-${adultIndex}-lastName`],
          Phoneno: values?.contact || "",
          Email: values?.email || "",
          PaxType: 1,
          LeadPassenger: roomIndex === 0 && adultIndex === 0,
          Age: 0,
        })
      );
    };

    const prepareChildPassengers = (room, roomIndex, values) => {
      return Array.from({ length: room?.numberOfChild }).map(
        (_, childIndex) => ({
          Title: values[`room-${roomIndex}-child-${childIndex}-title`],
          FirstName: values[`room-${roomIndex}-child-${childIndex}-firstName`],
          LastName: values[`room-${roomIndex}-child-${childIndex}-lastName`],
          PaxType: 2,
          Age: room?.childAge[childIndex] || 0,
        })
      );
    };

    roomInfo.forEach((room, roomIndex) => {
      hotelPassengers.push(
        ...prepareAdultPassengers(room, roomIndex, values),
        ...prepareChildPassengers(room, roomIndex, values)
      );
    });

    const getPricingDetails = (price) => ({
      CurrencyCode: price?.CurrencyCode || "INR",
      RoomPrice: price?.RoomPrice || 0,
      Tax: price?.Tax || 0,
      ExtraGuestCharge: price?.ExtraGuestCharge || 0,
      ChildCharge: price?.ChildCharge || 0,
      OtherCharges: price?.OtherCharges || 0,
      Discount: price?.Discount || 0,
      PublishedPrice: price?.PublishedPrice || 0,
      PublishedPriceRoundedOff: price?.PublishedPriceRoundedOff || 0,
      ServiceTax: price?.ServiceTax || 0,
      TCS: price?.TCS || 0,
      TDS: price?.TDS || 0,
      ServiceCharge: price?.ServiceCharge || 0,
      TotalGSTAmount: price?.TotalGSTAmount || 0,
    });

    const payload = {
      ...(couponId != null ? { coupon_id: Number(couponId) } : {}),
      ...(getUser?.id ? { user_id: Number(getUser.id) } : {}),
      booking_amount:
        selectedRoomData?.Price?.PublishedPriceRoundedOff * totalRooms,
      ResultIndex: resultIndex?.toString(),
      HotelCode: hotelDetails?.HotelInfoResult?.HotelDetails?.HotelCode || "",
      HotelName: hotelDetails?.HotelInfoResult?.HotelDetails?.HotelName || "",
      GuestNationality: values.GuestNationality || "IN",
      NoOfRooms: values.NoOfRooms?.toString() || totalRooms.toString() || "1",
      from_date: startDate,
      to_date: endDate,
      is_redeemed: isRedeem,
      HotelRoomsDetails: roomInfo.map((room, roomIndex) => ({
        RoomIndex: selectedRoomData?.RoomIndex?.toString(),
        RoomTypeCode: selectedRoomData?.RoomTypeCode || "",
        RoomTypeName: selectedRoomData?.RoomTypeName || "",
        RatePlanCode: selectedRoomData?.RatePlanCode || "",
        Price: getPricingDetails(selectedRoomData?.Price),
        HotelPassenger: [
          ...prepareAdultPassengers(room, roomIndex, values),
          ...prepareChildPassengers(room, roomIndex, values),
        ],
      })),
      deliveryInfo: {
        emails: [values?.email],
        contacts: [countryCode],
        billing_address: values?.billing_address?.toString() || "",
      },
      TraceId: hotelDetails?.HotelInfoResult?.TraceId || "",
    };

    try {
      const response = await gethotelbook(payload);
      window.location.href = response.data?.paymentResponse?.payment_links?.web;
    } catch (apiError) {
      const errorMessage = apiError?.response?.data?.message;
      setBookingMessageError(true);
      setBookingMessage(errorMessage);
    }
  };

  const [open, setOpen] = useState(false);

  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };

  const onChange = (e) => {
    setChecked(e.target.checked);
  };

  const [isOpen, setIsOpen] = useState(false);
  const [isOpenPayment, setIsOpenPayment] = useState(false);

  const togglePolicy = () => {
    setIsOpen((prev) => !prev);
  };
  const togglePayment = () => {
    setIsOpenPayment((prev) => !prev);
  };

  return (
    <>
      <section className="container hotel_payment mb-4">
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinishBook}
          onFinishFailed={onFinishFailed}
        >
          <Row gutter={16} className="mt-md-5 mt-4">
            <Col md={16}>
              <Card className="hotel-card mb-2 d-none d-md-block">
                <Title level={3} className="mb-2 fw-bold mb-md-4">
                  Property Information
                </Title>
                <Row gutter={16} className="hotel-details">
                  <Col md={8} xs={24} className="d-none">
                    <img
                      src={
                        hotelDetails?.HotelInfoResult?.HotelDetails?.Images?.[0]
                      }
                      className="img-fluid rounded object-cover"
                    />
                  </Col>
                  <Col md={16} xs={24}>
                    <div className="d-flex align-items-center mb-1">
                      <ul className="d-flex align-items-center gap-1 p-0 m-0">
                        <Rate
                          disabled
                          value={
                            hotelDetails?.HotelInfoResult?.HotelDetails
                              ?.StarRating
                          }
                        />
                      </ul>
                      <span className="ms-2">{hotelDetails?.hotel?.pt}</span>
                    </div>
                    <Title level={4} className="fw-bold mb-0">
                      {hotelDetails?.HotelInfoResult?.HotelDetails?.HotelName}
                    </Title>
                    {/* <small className='mb-3 d-block'>{hotelDetails?.HotelInfoResult?.HotelDetails?.Description}</small> */}
                    <Title level={5} className="m-0 mb-2 fw-bold">
                      <FaMapMarkedAlt className="me-1" />
                      Location Information
                    </Title>
                    <ul className="hotel-services">
                      {hotelDetails?.HotelInfoResult?.HotelDetails?.Address}
                    </ul>
                  </Col>
                </Row>
              </Card>

              <Card className="card mb-md-2 booking_details d-none d-md-block">
                <div>
                  <Title level={3} className="mb-2 fw-bold mb-md-4">
                    Your Booking Details
                  </Title>
                  <div className="d-flex align-items-center justify-content-between gap-3 mb-3 mb-md-4">
                    <div className="booking_box bg-light-success">
                      <Title level={5} className="mb-0 fw-bold">
                        Check-in
                      </Title>
                      <p>{formatDate(startDate)}</p>
                    </div>
                    <div className="booking_box bg-light-danger">
                      <Title level={5} className="mb-0 fw-bold">
                        Check-out
                      </Title>
                      <p>{formatDate(endDate)}</p>
                    </div>
                  </div>
                  <ul className="Hotel_services">
                    <li>
                      You Will Stay {nights} Night{nights > 1 ? "s" : ""}{" "}
                    </li>
                    <li>You Selected {totalRooms} Rooms For :</li>
                    <li>{totalNOAdults} Adults</li>
                    {/* <li>{totalNOChildren} Children (12 ,7 and 5 Years Old)</li> */}
                    <li>{totalNOChildren} Children</li>
                  </ul>
                </div>
              </Card>

              <div className="card d-md-none">
                <Row gutter={16} className="hotel-details border-bottom px-3 py-3">
                  <Col xs={24}>
                    <div className="d-flex align-items-center mb-1">
                      <ul className="d-flex align-items-center gap-1 p-0 m-0">
                        <Rate
                          disabled
                          value={
                            hotelDetails?.HotelInfoResult?.HotelDetails
                              ?.StarRating
                          }
                        />
                      </ul>
                      <span className="ms-2">{hotelDetails?.hotel?.pt}</span>
                    </div>
                    <Title level={4} className="fw-bold mb-0">
                      {hotelDetails?.HotelInfoResult?.HotelDetails?.HotelName}
                    </Title>
                    {/* <small className='mb-3 d-block'>{hotelDetails?.HotelInfoResult?.HotelDetails?.Description}</small> */}
                    <Title level={5} className="m-0 mb-2 fw-bold">
                      <FaMapMarkedAlt className="me-1" />
                      Location Information
                    </Title>
                    <ul className="hotel-services">
                      {hotelDetails?.HotelInfoResult?.HotelDetails?.Address}
                    </ul>
                  </Col>
                </Row>

                <div className=" border-bottom px-3 py-3">
                  <div className="d-flex align-items-center justify-content-between gap-3">
                    <div className="booking_box">
                      <p className="mb-0 fw-normal lh-sm">
                        Check-in
                      </p>
                      <p className="fw-bold lh-sm">{formatDate(startDate)}</p>
                    </div>
                    <small className="bg-light px-2 py-1 rounded fw-bold border">{nights} Night{nights > 1 ? "s" : ""}{" "}</small>
                    <div className="booking_box">
                      <p className="mb-0 fw-normal lh-sm">
                        Check-out
                      </p>
                      <p className="fw-bold lh-sm">{formatDate(endDate)}</p>
                    </div>
                  </div>
                </div>

                <div className="px-3 py-3">
                  <p className="mb-0 fw-normal lh-sm">Guest & Rooms</p>
                  <p className="fw-bold lh-sm">{totalNOAdults} Adults</p>
                  <p className="fw-bold lh-sm">{totalNOChildren} Children</p>
                  <p className="fw-bold lh-sm">{totalRooms} Room</p>
                </div>
              </div>

              <div className="card mb-md-2 payment_details">
                <div className="card-body">
                  <h3
                    className="fw-bold mb-0 d-flex align-items-center justify-content-between"
                    style={{ cursor: "pointer" }}
                    onClick={togglePolicy}
                  >
                    Cancellation Policy
                    {isOpen ? <FaChevronUp /> : <FaChevronDown />}
                  </h3>

                  {isOpen && (
                    <CancellationPolicyHotel
                      policyData={selectedRoomData?.CancellationPolicy}
                    />
                  )}
                </div>
              </div>

              <div className="card d-md-none">
                <div className="card-body">
                  <h3
                    className="fw-bold mb-0 d-flex align-items-center justify-content-between"
                    style={{ cursor: "pointer" }}
                    onClick={togglePayment}
                  >
                    Payment Detail
                    {isOpenPayment ? <FaChevronUp /> : <FaChevronDown />}
                  </h3>
                  {isOpenPayment && (
                    <div>
                      {selectedRoomData?.Price?.TotalPublishFare !== 0 ? (
                        <>
                          {!applyDiscountShow ? (
                            <>
                              <div className="d-flex align-items-center justify-content-between mt-3">
                                <Text>Base Fare</Text>
                                <Text>
                                  <b>
                                    ₹
                                    {Math.round(
                                      selectedRoomData?.Price
                                        ?.TotalPublishFare * totalRooms
                                    )}
                                    /-
                                  </b>
                                </Text>
                              </div>
                              <div className="d-flex align-items-center justify-content-between">
                                <Text>Total Discount</Text>
                                <Text>
                                  <b>
                                    <span className="text-danger">
                                      ₹
                                      {Math.round(
                                        selectedRoomData?.Price
                                          ?.discountAmount * totalRooms
                                      )}
                                    </span>
                                    /-
                                  </b>
                                </Text>
                              </div>

                              <div className="d-flex align-items-center justify-content-between">
                                <Text>Price after Discount</Text>
                                <Text>
                                  <b>
                                    ₹
                                    {Math.round(
                                      selectedRoomData?.Price
                                        ?.PublishedPriceRoundedOff
                                    )}
                                    /-
                                  </b>
                                </Text>
                              </div>

                              <div className="d-flex align-items-center justify-content-between">
                                <Text>
                                  {nights} Night{nights > 1 ? "s" : ""}
                                </Text>
                                <Text>
                                  <b>
                                    ₹
                                    {Math.round(
                                      nights *
                                      selectedRoomData?.Price
                                        ?.PublishedPriceRoundedOff
                                    )}
                                    /-
                                  </b>
                                </Text>
                              </div>

                              <div className="d-flex align-items-center justify-content-between">
                                <Text>Taxes & Fees </Text>
                                <Text>
                                  <b>
                                    ₹
                                    {Math.round(
                                      nights *
                                      selectedRoomData?.Price?.ServiceTax *
                                      totalRooms
                                    )}
                                    /-
                                  </b>
                                </Text>
                              </div>

                              <div className="text-center mt-3 bg-light-success p-2 rounded">
                                <h3 className=" d-flex justify-content-between">
                                  Total:{" "}
                                  <span className="fw-bold">
                                    ₹
                                    {Math.round(
                                      (nights *
                                        selectedRoomData?.Price
                                          ?.PublishedPriceRoundedOff *
                                        totalRooms || 0) +
                                      (nights *
                                        selectedRoomData?.Price?.ServiceTax *
                                        totalRooms || 0)
                                    )}
                                  </span>
                                </h3>
                              </div>
                            </>
                          ) : (
                            <>
                              <div className="d-flex align-items-center justify-content-between mt-3">
                                <Text>
                                  Base Fare * {nights} Night
                                  {nights > 1 ? "s" : ""}
                                </Text>
                                <Text>
                                  <b>
                                    ₹
                                    {Math.round(
                                      nights *
                                      selectedRoomData?.Price
                                        ?.TotalPublishFare *
                                      totalRooms
                                    )}
                                    /-
                                  </b>
                                </Text>
                              </div>

                              <div className="d-flex align-items-center justify-content-between">
                                <Text>Total Discount</Text>
                                <Text>
                                  <b>
                                    <span className="text-danger">
                                      ₹{Math.round(discountAmountOffer)}
                                    </span>
                                    /-
                                  </b>
                                </Text>
                              </div>

                              <div className="d-flex align-items-center justify-content-between">
                                <Text>Price after Discount</Text>
                                <Text>
                                  <b>
                                    ₹
                                    {Math.round(
                                      nights *
                                      selectedRoomData?.Price
                                        ?.TotalPublishFare *
                                      totalRooms -
                                      discountAmountOffer
                                    )}
                                    /-
                                  </b>
                                </Text>
                              </div>

                              <div className="d-flex align-items-center justify-content-between">
                                <Text>Taxes & Fees </Text>
                                <Text>
                                  <b>
                                    ₹
                                    {Math.round(
                                      nights *
                                      selectedRoomData?.Price?.ServiceTax *
                                      totalRooms
                                    )}
                                    /-
                                  </b>
                                </Text>
                              </div>

                              <div className="text-center mt-3 bg-light-success p-2 rounded">
                                <h3 className=" d-flex justify-content-between">
                                  Total:{" "}
                                  <span className="fw-bold">
                                    ₹
                                    {Math.round(
                                      totalAfterDiscount +
                                      nights *
                                      selectedRoomData?.Price?.ServiceTax *
                                      totalRooms
                                    )}
                                  </span>
                                </h3>
                              </div>
                            </>
                          )}
                        </>
                      ) : (
                        <>
                          <div className="d-flex align-items-center justify-content-between mt-3">
                            <Text>Base Fare</Text>
                            <Text>
                              ₹{" "}
                              {Math.round(
                                selectedRoomData?.Price
                                  ?.PublishedPriceRoundedOff * totalRooms
                              )}
                              /-
                            </Text>
                          </div>

                          <div className="d-flex align-items-center justify-content-between mt-3">
                            <Text>Taxes & Fees </Text>
                            <Text>
                              ₹
                              {Math.round(
                                selectedRoomData?.Price?.ServiceTax * totalRooms
                              )}
                              /-
                            </Text>
                          </div>

                          <div className="text-center mt-3 bg-light-success p-2 rounded">
                            <h3 className=" d-flex justify-content-between">
                              Total:{" "}
                              <span>
                                ₹{" "}
                                {Math.round(
                                  (selectedRoomData?.Price
                                    ?.PublishedPriceRoundedOff * totalRooms ||
                                    0) +
                                  (selectedRoomData?.Price?.ServiceTax *
                                    totalRooms || 0)
                                )}
                              </span>
                            </h3>
                          </div>
                        </>
                      )}
                    </div>
                  )}
                </div>
              </div>

              <HotelOffersMobile
                appliedCheckLogin={appliedCheckLogin}
                setAppliedCheckLogin={setAppliedCheckLogin}
                applyDiscount={applyDiscount}
                totalAfterDiscount={totalAfterDiscount}
                setApplyDiscountShow={setApplyDiscountShow}
                applyDiscountShow={applyDiscountShow}
                isCongratulations={isCongratulations}
                setIsCongratulations={setIsCongratulations}
                isValidCoupon={isValidCoupon}
                setValidCoupon={setValidCoupon}
              />

              <Card
                className={
                  !isOtherDivActive
                    ? "card mb-md-2 Edit_Profile"
                    : "card mb-md-2 Edit_Profile d-none"
                }
              >
                {/* <Title level={4} className="fw-bold m-0 mb-3">
                  Guest Details{" "}
                  <Tooltip
                    title="Please make sure you enter the Name as per your Government photo ID."
                    placement="right"
                  >
                    <InfoCircleOutlined style={{ color: "#1890ff", marginLeft: 8, cursor: "pointer" }} />
                  </Tooltip>
                </Title> */}
                <Title level={4} className="fw-bold m-0">
                  Guest Details
                </Title>

                <div className="my-2" style={{ display: "flex", alignItems: "center", color: "#c15a0a", fontSize: 14 }}>
                  <InfoCircleOutlined style={{ marginRight: 8, fontSize: 16 }} />
                  <Text style={{ color: "#c15a0a" }}>
                    Please make sure you enter the Name as per your Government photo id.
                  </Text>
                </div>

                {/* {roomInfo?.map((room, roomIndex) => (
                  <div key={`room-${roomIndex}`} className="">
                    <h3 className="mb-2">Room {roomIndex + 1}</h3>
                    {Array.from({ length: room?.numberOfAdults }).map(
                      (_, adultIndex) => (
                        <Row
                          gutter={16}
                          key={`room-${roomIndex}-adult-${adultIndex}`}
                        >
                          <Col md={6} xs={24}>
                            <Form.Item
                              name={`room-${roomIndex}-adult-${adultIndex}-title`}
                              label={`Adult ${adultIndex + 1} - Title`}
                              rules={[
                                {
                                  required: true,
                                  message: "Please select a title!",
                                },
                              ]}
                            >
                              <Select
                                className="from-control"
                                placeholder="Select Title"
                              >
                                <Select.Option value="Mr">Mr</Select.Option>
                                <Select.Option value="Mrs">Mrs</Select.Option>
                                <Select.Option value="Ms">Ms</Select.Option>
                              </Select>

                            </Form.Item>
                          </Col>
                          <Col md={9} xs={24}>
                            <Form.Item
                              name={`room-${roomIndex}-adult-${adultIndex}-firstName`}
                              label="First Name"
                              rules={[
                                {
                                  required: true,
                                  message: "First Name is required!",
                                },
                              ]}
                            >
                              <FilteredInput
                                className="from-control"
                                placeholder="First Name"
                              />
                            </Form.Item>
                          </Col>
                          <Col md={9} xs={24}>
                            <Form.Item
                              name={`room-${roomIndex}-adult-${adultIndex}-lastName`}
                              label="Last Name"
                              rules={[
                                {
                                  required: true,
                                  message: "Last Name is required!",
                                },
                              ]}
                            >
                              <FilteredInput
                                className="from-control"
                                placeholder="Last Name"
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                      )
                    )}

                    {Array.from({ length: room?.numberOfChild }).map(
                      (_, childIndex) => (
                        <Row
                          gutter={16}
                          key={`room-${roomIndex}-child-${childIndex}`}
                        >
                          <Col md={6} xs={24} className="mb-3">
                            <Form.Item
                              name={`room-${roomIndex}-child-${childIndex}-title`}
                              label={`Child ${childIndex + 1} - Title`}
                              rules={[
                                {
                                  required: true,
                                  message: "Please select a title!",
                                },
                              ]}
                            >
                              <Select
                                className="from-control"
                                placeholder="Select Title"
                              >
                                <Select.Option value="Master">Master</Select.Option>
                                <Select.Option value="Miss">Miss</Select.Option>
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col md={9} xs={24} className="mb-3">
                            <Form.Item
                              name={`room-${roomIndex}-child-${childIndex}-firstName`}
                              label={`First Name (Age: ${room?.childAge[childIndex]}Y)`}
                              rules={[
                                {
                                  required: true,
                                  message: "First Name is required!",
                                },
                              ]}
                            >
                              <FilteredInput
                                className="from-control"
                                placeholder="First Name"
                              />
                            </Form.Item>
                          </Col>
                          <Col md={9} xs={24} className="mb-3">
                            <Form.Item
                              name={`room-${roomIndex}-child-${childIndex}-lastName`}
                              label="Last Name"
                              rules={[
                                {
                                  required: true,
                                  message: "Last Name is required!",
                                },
                              ]}
                            >
                              <FilteredInput
                                className="from-control"
                                placeholder="Last Name"
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                      )
                    )}
                  </div>
                ))} */}

                <Collapse
                  accordion={false}
                  activeKey={activeKeys}
                  onChange={(keys) => setActiveKeys(Array.isArray(keys) ? keys : [keys])}
                  className="site-collapse-custom-collapse"
                >
                  {roomInfo?.map((room, roomIndex) => (
                    <Panel
                      header={`Room ${roomIndex + 1} (${room.numberOfAdults} Adult${room.numberOfAdults > 1 ? "s" : ""
                        }${room.numberOfChild > 0 ? `, ${room.numberOfChild} Child` : ""})`}
                      key={String(roomIndex)}
                      data-panel-key={String(roomIndex)}  
                      className="site-collapse-custom-panel"
                    >
                      <div key={`room-${roomIndex}`} className="">
                        {/* <h3 className="mb-2">Room {roomIndex + 1}</h3> */}
                        {Array.from({ length: room?.numberOfAdults }).map(
                          (_, adultIndex) => (
                            <Row
                              gutter={16}
                              key={`room-${roomIndex}-adult-${adultIndex}`}
                            >
                              <Col md={6} xs={24}>
                                <Form.Item
                                  name={`room-${roomIndex}-adult-${adultIndex}-title`}
                                  label={`Adult ${adultIndex + 1} - Title`}
                                  rules={[
                                    {
                                      required: true,
                                      message: "Please select a title!",
                                    },
                                  ]}
                                >
                                  <Select
                                    className="from-control"
                                    placeholder="Select Title"
                                  >
                                    <Select.Option value="Mr">Mr</Select.Option>
                                    <Select.Option value="Mrs">Mrs</Select.Option>
                                    <Select.Option value="Ms">Ms</Select.Option>
                                  </Select>

                                </Form.Item>
                              </Col>
                              <Col md={9} xs={24}>
                                <Form.Item
                                  name={`room-${roomIndex}-adult-${adultIndex}-firstName`}
                                  label="First Name"
                                  rules={[
                                    {
                                      required: true,
                                      message: "First Name is required!",
                                    },
                                  ]}
                                >
                                  <FilteredInput
                                    className="from-control"
                                    placeholder="First Name"
                                  />
                                </Form.Item>
                              </Col>
                              <Col md={9} xs={24}>
                                <Form.Item
                                  name={`room-${roomIndex}-adult-${adultIndex}-lastName`}
                                  label="Last Name"
                                  rules={[
                                    {
                                      required: true,
                                      message: "Last Name is required!",
                                    },
                                  ]}
                                >
                                  <FilteredInput
                                    className="from-control"
                                    placeholder="Last Name"
                                  />
                                </Form.Item>
                              </Col>
                            </Row>
                          )
                        )}

                        {Array.from({ length: room?.numberOfChild }).map(
                          (_, childIndex) => (
                            <Row
                              gutter={16}
                              key={`room-${roomIndex}-child-${childIndex}`}
                            >
                              <Col md={6} xs={24} className="mb-3">
                                <Form.Item
                                  name={`room-${roomIndex}-child-${childIndex}-title`}
                                  label={`Child ${childIndex + 1} - Title`}
                                  rules={[
                                    {
                                      required: true,
                                      message: "Please select a title!",
                                    },
                                  ]}
                                >
                                  <Select
                                    className="from-control"
                                    placeholder="Select Title"
                                  >
                                    <Select.Option value="Master">Master</Select.Option>
                                    <Select.Option value="Miss">Miss</Select.Option>
                                  </Select>
                                </Form.Item>
                              </Col>
                              <Col md={9} xs={24} className="mb-3">
                                <Form.Item
                                  name={`room-${roomIndex}-child-${childIndex}-firstName`}
                                  label={`First Name (Age: ${room?.childAge[childIndex]}Y)`}
                                  rules={[
                                    {
                                      required: true,
                                      message: "First Name is required!",
                                    },
                                  ]}
                                >
                                  <FilteredInput
                                    className="from-control"
                                    placeholder="First Name"
                                  />
                                </Form.Item>
                              </Col>
                              <Col md={9} xs={24} className="mb-3">
                                <Form.Item
                                  name={`room-${roomIndex}-child-${childIndex}-lastName`}
                                  label="Last Name"
                                  rules={[
                                    {
                                      required: true,
                                      message: "Last Name is required!",
                                    },
                                  ]}
                                >
                                  <FilteredInput
                                    className="from-control"
                                    placeholder="Last Name"
                                  />
                                </Form.Item>
                              </Col>
                            </Row>
                          )
                        )}
                      </div>
                    </Panel>
                  ))}
                </Collapse>

              </Card>

              <Card className="mb-md-0 mb-5 ">
                <Row gutter={16}>
                  <Col md={12} xs={24} className="w-100">
                    <Form.Item
                      name="contacts"
                      label="Mobile Number"
                      rules={[
                        {
                          required: true,
                          validator: validatePhone,
                        },
                      ]}
                      validateTrigger={['onSubmit']}
                    >
                      <PhoneInput
                        defaultCountry={'in'}
                        forceDialCode={true}
                        disableDialCodeAndPrefix={true}
                        showDisabledDialCodeAndPrefix={true}
                        placeholder="Enter Mobile Number"
                        className="w-100 custom-phone-inputs"
                        disableFormatting={true}
                        value={phoneValue}
                        onChange={handlePhoneChange}
                      />
                    </Form.Item>
                  </Col>

                  <Col md={12} xs={24} className="w-100">
                    <Form.Item
                      name="email"
                      label="Email Address"
                      rules={[
                        {
                          required: true,
                          message: "Email  is required",
                        },
                        {
                          type: "email",
                          message: "Please enter a valid email address",
                        },
                      ]}
                    >
                      <FilteredInput
                        placeholder="xyz@gmail.com"
                        prefix={<FaRegEnvelope />}
                        className="from-control"
                        style={{ height: "41px" }}
                      />
                    </Form.Item>
                  </Col>

                  <Col md={24} xs={24} className="mb-3">
                    <Form.Item
                      name="billing_address"
                      label="Billing Address"
                      rules={[
                        {
                          required: true,
                          message: "Billing addressr is required!",
                        },
                      ]}
                      className="mb-0"
                    >
                      <TextArea placeholder="Billing address" rows={3} />
                    </Form.Item>
                  </Col>

                  <Col xs={24} className="traveller-details">
                    <Title level={5} className="fw-bold mb-2">
                      <Checkbox onChange={onChange} className="me-3 me-md-2" />{" "}
                      Enter GST Details (Optional)
                    </Title>

                    {checked && (
                      <div className="mb-2">
                        <Row gutter={16}>
                          <Col md={8} xs={24}>
                            <Form.Item
                              name="gstNumber"
                              label="GST Number"
                              rules={[
                                {
                                  required: true,
                                  message: "Please enter GST Number",
                                },
                              ]}
                            >
                              <FilteredInput placeholder="Enter GST Number" />
                            </Form.Item>
                          </Col>
                          <Col md={8} xs={24}>
                            <Form.Item
                              name="companyName"
                              label="Company Name"
                              rules={[
                                {
                                  required: true,
                                  message: "Please enter Company Name",
                                },
                              ]}
                            >
                              <FilteredInput placeholder="Enter Company Name" />
                            </Form.Item>
                          </Col>
                          <Col md={8} xs={24}>
                            <Form.Item
                              name="businessEmail"
                              label="Business Email ID"
                              rules={[
                                {
                                  required: true,
                                  message: "Please enter Business Email ID",
                                },
                                {
                                  type: "email",
                                  message: "Please enter a valid email",
                                },
                              ]}
                            >
                              <FilteredInput
                                placeholder="Enter Business Email ID"
                                prefix={<FaRegEnvelope />}
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row gutter={16}>
                          <Col md={8} xs={24}>
                            <Form.Item
                              name="mobile"
                              label="Mobile Number"
                              rules={[
                                {
                                  required: true,
                                  message: "Please enter Mobile Number",
                                },
                              ]}
                            >
                              <FilteredInput placeholder="Enter Mobile Number" />
                            </Form.Item>
                          </Col>
                          <Col md={16} xs={24}>
                            <Form.Item
                              name="companyAddress"
                              label="Company Address"
                              rules={[
                                {
                                  required: true,
                                  message: "Please enter Company Address",
                                },
                              ]}
                            >
                              <FilteredInput placeholder="Enter Company Address" />
                            </Form.Item>
                          </Col>
                        </Row>
                      </div>
                    )}

                    <Form.Item
                      name="agree"
                      valuePropName="checked"
                      className="mb-0"
                      rules={[
                        {
                          validator: (_, value) =>
                            value
                              ? Promise.resolve()
                              : Promise.reject(
                                "Please click on checkbox to continue."
                              ),
                        },
                      ]}
                    >
                      <span className="mb-md-2 d-flex align-items-start gap-2">
                        <Checkbox className="me-2" />
                        <label htmlFor="terms">
                          I understand and agree with the , the{" "}
                          <Link
                            aria-label="Privacy Policy"
                            to="/privacy-policy"
                            target="_blank"
                            className="text-primary"
                          >
                            Privacy Policy
                          </Link>
                          , the{" "}
                          <Link
                            aria-label="User Agreement"
                            to="/user-agreement"
                            target="_blank"
                            className="text-primary"
                          >
                            User Agreement
                          </Link>{" "}
                          and{" "}
                          <Link
                            aria-label="Terms and Conditions"
                            to="/terms-conditions"
                            target="_blank"
                            className="text-primary"
                          >
                            Fare Rules, Terms & Conditions
                          </Link>{" "}
                          of SuperbWorldTrip.
                        </label>
                      </span>
                    </Form.Item>
                  </Col>

                  <Col xs={24}>
                    <Button
                      htmlType="submit"
                      className="btn-primary px-4 mt-2 text-center rounded text-white border-0 d-md-block d-none fs-6"
                      aria-label="Pay now"
                    >
                      {isFormValid ? "Continue To Pay" : "Proceed To Pay"}
                    </Button>
                  </Col>
                </Row>
              </Card>
            </Col>

            <Col md={8} xs={24}>
              <div className="sticky-cls-top">
                <div className="card d-md-block d-none">
                  <div className="card-body">
                    <h3 className="mb-3 fw-bold">Payment Detail</h3>
                    {selectedRoomData?.Price?.TotalPublishFare !== 0 ? (
                      <>
                        {!applyDiscountShow ? (
                          <>
                            <div className="d-flex align-items-center justify-content-between mt-3">
                              <Text>Base Fare</Text>
                              <Text>
                                <b>
                                  ₹
                                  {Math.round(
                                    selectedRoomData?.Price?.TotalPublishFare *
                                    totalRooms
                                  )}
                                  /-
                                </b>
                              </Text>
                            </div>
                            <div className="d-flex align-items-center justify-content-between">
                              <Text>Total Discount</Text>
                              <Text>
                                <b>
                                  <span className="text-danger">
                                    ₹
                                    {Math.round(
                                      selectedRoomData?.Price?.discountAmount
                                    )}
                                  </span>
                                  /-
                                </b>
                              </Text>
                            </div>

                            <div className="d-flex align-items-center justify-content-between">
                              <Text>Price after Discount</Text>
                              <Text>
                                <b>
                                  ₹
                                  {Math.round(
                                    selectedRoomData?.Price
                                      ?.PublishedPriceRoundedOff * totalRooms
                                  )}
                                  /-
                                </b>
                              </Text>
                            </div>

                            <div className="d-flex align-items-center justify-content-between">
                              <Text>
                                {nights} Night{nights > 1 ? "s" : ""}
                              </Text>
                              <Text>
                                <b>
                                  ₹
                                  {Math.round(
                                    nights *
                                    selectedRoomData?.Price
                                      ?.PublishedPriceRoundedOff *
                                    totalRooms
                                  )}
                                  /-
                                </b>
                              </Text>
                            </div>

                            <div className="d-flex align-items-center justify-content-between">
                              <Text>Taxes & Fees </Text>
                              <Text>
                                <b>
                                  ₹
                                  {Math.round(
                                    nights *
                                    selectedRoomData?.Price?.ServiceTax *
                                    totalRooms
                                  )}
                                  /-
                                </b>
                              </Text>
                            </div>

                            <div className="text-center mt-3 bg-light-success p-2 rounded">
                              <h3 className=" d-flex justify-content-between">
                                Total:{" "}
                                <span className="fw-bold">
                                  ₹
                                  {Math.round(
                                    (nights *
                                      selectedRoomData?.Price
                                        ?.PublishedPriceRoundedOff *
                                      totalRooms || 0) +
                                    (nights *
                                      selectedRoomData?.Price?.ServiceTax *
                                      totalRooms || 0)
                                  )}
                                </span>
                              </h3>
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="d-flex align-items-center justify-content-between mt-3">
                              <Text>
                                Base Fare * {nights} Night
                                {nights > 1 ? "s" : ""}
                              </Text>
                              <Text>
                                <b>
                                  ₹
                                  {Math.round(
                                    nights *
                                    selectedRoomData?.Price
                                      ?.TotalPublishFare *
                                    totalRooms
                                  )}
                                  /-
                                </b>
                              </Text>
                            </div>

                            <div className="d-flex align-items-center justify-content-between">
                              <Text>Total Discount</Text>
                              <Text>
                                <b>
                                  <span className="text-danger">
                                    ₹{Math.round(discountAmountOffer)}
                                  </span>
                                  /-
                                </b>
                              </Text>
                            </div>

                            <div className="d-flex align-items-center justify-content-between">
                              <Text>Price after Discount</Text>
                              <Text>
                                <b>
                                  ₹
                                  {Math.round(
                                    nights *
                                    selectedRoomData?.Price
                                      ?.TotalPublishFare *
                                    totalRooms -
                                    discountAmountOffer
                                  )}
                                  /-
                                </b>
                              </Text>
                            </div>

                            {/* <div className="d-flex align-items-center justify-content-between">
                                                        <Text>{nights} Night{nights > 1 ? "s" : ""}</Text>
                                                        <Text><b>₹{Math.round(nights * selectedRoomData?.Price?.TotalPublishFare - discountAmountOffer)}/-</b></Text>
                                                    </div> */}

                            <div className="d-flex align-items-center justify-content-between">
                              <Text>Taxes & Fees </Text>
                              <Text>
                                <b>
                                  ₹
                                  {Math.round(
                                    nights *
                                    selectedRoomData?.Price?.ServiceTax *
                                    totalRooms
                                  )}
                                  /-
                                </b>
                              </Text>
                            </div>

                            <div className="text-center mt-3 bg-light-success p-2 rounded">
                              <h3 className=" d-flex justify-content-between">
                                Total:{" "}
                                <span className="fw-bold">
                                  ₹
                                  {Math.round(
                                    totalAfterDiscount +
                                    nights *
                                    selectedRoomData?.Price?.ServiceTax *
                                    totalRooms
                                  )}
                                </span>
                              </h3>
                            </div>
                          </>
                        )}
                      </>
                    ) : (
                      <>
                        <div className="d-flex align-items-center justify-content-between mt-3">
                          <Text>Base Fare</Text>
                          <Text>
                            ₹{" "}
                            {Math.round(
                              selectedRoomData?.Price
                                ?.PublishedPriceRoundedOff * totalRooms
                            )}
                            /-
                          </Text>
                        </div>

                        <div className="d-flex align-items-center justify-content-between mt-3">
                          <Text>Taxes & Fees </Text>
                          <Text>
                            ₹
                            {Math.round(
                              selectedRoomData?.Price?.ServiceTax * totalRooms
                            )}
                            /-
                          </Text>
                        </div>

                        <div className="text-center mt-3 bg-light-success p-2 rounded">
                          <h3 className=" d-flex justify-content-between">
                            Total:{" "}
                            <span>
                              ₹{" "}
                              {Math.round(
                                (selectedRoomData?.Price
                                  ?.PublishedPriceRoundedOff * totalRooms ||
                                  0) +
                                (selectedRoomData?.Price?.ServiceTax *
                                  totalRooms || 0)
                              )}
                            </span>
                          </h3>
                        </div>
                      </>
                    )}

                    <div className="mt-4 border-0">
                      <Button
                        htmlType="submit"
                        className="btn-primary px-4 full-width text-center rounded text-white border-0 fs-6 py-2 d-block"
                        aria-label="pay now"
                      >
                        {isFormValid ? "Continue To Pay" : "Proceed To Pay"}
                      </Button>
                    </div>
                  </div>
                </div>
                <div className="footer-price d-md-none">
                  <div className="footer-price-content">
                    {loading ? (
                      <div className="d-flex align-items-center gap-2">
                        <div className="spinner"></div>
                      </div>
                    ) : (
                      <>
                        <div>
                          <h2 className="fw-bold d-flex align-items-center gap-2">
                            ₹
                            {Math.round(
                              (selectedRoomData?.Price
                                ?.PublishedPriceRoundedOff * totalRooms || 0) +
                              (selectedRoomData?.Price?.ServiceTax *
                                totalRooms || 0)
                            )}
                            <Popover
                              content={
                                <div>
                                  {selectedRoomData?.Price?.TotalPublishFare !==
                                    0 ? (
                                    <>
                                      <div>
                                        <div className="d-flex align-items-center justify-content-between">
                                          <Text>Base Fare: </Text>
                                          <Text>
                                            <b>
                                              ₹
                                              {Math.round(
                                                selectedRoomData?.Price
                                                  ?.TotalPublishFare *
                                                totalRooms
                                              )}
                                              /-
                                            </b>
                                          </Text>
                                        </div>
                                        <div className="d-flex align-items-center justify-content-between">
                                          <Text>Total Discount: </Text>
                                          <Text>
                                            <b className="text-danger">
                                              ₹
                                              {Math.round(
                                                selectedRoomData?.Price
                                                  ?.discountAmount
                                              )}
                                              /-
                                            </b>
                                          </Text>
                                        </div>
                                        <div className="d-flex align-items-center justify-content-between">
                                          <Text>Price after Discount: </Text>
                                          <Text className="ms-1">
                                            <b>
                                              ₹
                                              {Math.round(
                                                selectedRoomData?.Price
                                                  ?.PublishedPriceRoundedOff *
                                                totalRooms
                                              )}
                                              /-
                                            </b>
                                          </Text>
                                        </div>
                                        <div className="d-flex align-items-center justify-content-between">
                                          <Text>
                                            {nights} Night
                                            {nights > 1 ? "s" : ""}
                                          </Text>
                                          <Text>
                                            <b>
                                              ₹
                                              {Math.round(
                                                nights *
                                                selectedRoomData?.Price
                                                  ?.PublishedPriceRoundedOff *
                                                totalRooms
                                              )}
                                              /-
                                            </b>
                                          </Text>
                                        </div>
                                        <div className="d-flex align-items-center justify-content-between">
                                          <Text>Taxes & Fees: </Text>
                                          <Text>
                                            <b>
                                              ₹
                                              {Math.round(
                                                selectedRoomData?.Price
                                                  ?.ServiceTax * totalRooms
                                              )}
                                              /-
                                            </b>
                                          </Text>
                                        </div>
                                      </div>
                                    </>
                                  ) : (
                                    <>
                                      <div className="bg-light-primary p-2 rounded">
                                        <div className="d-flex align-items-center justify-content-between">
                                          <Text>Base Fare: </Text>
                                          <Text>
                                            ₹
                                            {Math.round(
                                              selectedRoomData?.Price
                                                ?.PublishedPriceRoundedOff *
                                              totalRooms
                                            )}
                                            /-
                                          </Text>
                                        </div>
                                        <hr />
                                        <div className="d-flex align-items-center justify-content-between">
                                          <Text>Taxes & Fees: </Text>
                                          <Text>
                                            ₹
                                            {Math.round(
                                              nights *
                                              selectedRoomData?.Price
                                                ?.ServiceTax *
                                              totalRooms
                                            )}
                                            /-
                                          </Text>
                                        </div>
                                      </div>

                                      <div className="d-flex align-items-center justify-content-between">
                                        <Text>Redeem: </Text>
                                        <Checkbox
                                          onChange={handleChange}
                                          checked={isReedom}
                                        >
                                          Redeem Discount
                                        </Checkbox>
                                      </div>

                                      <div className="d-flex justify-content-between align-items-center my-2">
                                        <p className="text-muted mb-0"></p>
                                        <p
                                          className="mb-0 fw-bold text-success"
                                          style={{ fontSize: "1.2rem" }}
                                        ></p>
                                      </div>
                                    </>
                                  )}
                                  <div className="text-center mt-2 bg-light-success p-1 rounded">
                                    <h3 className="d-flex justify-content-between">
                                      Total Price:
                                      <span className="ms-1 fw-bold">
                                        ₹
                                        {Math.round(
                                          (selectedRoomData?.Price
                                            ?.PublishedPriceRoundedOff *
                                            totalRooms || 0) +
                                          (selectedRoomData?.Price
                                            ?.ServiceTax * totalRooms || 0)
                                        )}
                                      </span>
                                    </h3>
                                  </div>
                                </div>
                              }
                              title="Payment Detail"
                              trigger="click"
                              open={open}
                              onOpenChange={handleOpenChange}
                              className="booking-filter"
                            >
                              <span>
                                <FaInfoCircle />
                              </span>
                            </Popover>
                          </h2>
                          <p>
                            {totalRooms} Room{totalRooms > 1 ? "s" : ""}
                            &nbsp;For
                            {(() => {
                              const adults = totalNOAdults || 0;
                              const children = totalNOChildren || 0;
                              const totalGuest = adults + children;
                              return ` ${totalGuest} `;
                            })()}
                            Guest
                          </p>
                        </div>
                      </>
                    )}

                    <Button
                      htmlType="submit"
                      className="btn bg-light-primary d-inline-block float-end rounded my-3 px-4 fw-bold fs-6 py-2"
                      aria-label="pay now"
                    >
                      {isFormValid ? "Continue To Pay" : "Proceed To Pay"}
                    </Button>
                  </div>
                </div>

                <HotelOffers
                  appliedCheckLogin={appliedCheckLogin}
                  setAppliedCheckLogin={setAppliedCheckLogin}
                  applyDiscount={applyDiscount}
                  totalAfterDiscount={totalAfterDiscount}
                  setApplyDiscountShow={setApplyDiscountShow}
                  applyDiscountShow={applyDiscountShow}
                  isCongratulations={isCongratulations}
                  setIsCongratulations={setIsCongratulations}
                  isValidCoupon={isValidCoupon}
                  setValidCoupon={setValidCoupon}
                />
              </div>
            </Col>
          </Row>
        </Form>

        <Modal
          className="Gallery_cntr p-3"
          open={bookingLoader}
          footer={null}
          onCancel={() => {
            setBookingLoader(false), setBookingMessageError(false);
          }}
          centered
          destroyOnClose={true}
          width={400}
        >
          {!bookingMessageError ? (
            <div className="text-center py-5">
              <img
                loading="lazy"
                src={flightLoader}
                style={{ height: "100px", width: "100px" }}
                alt="loader"
              />
              <h4>Loading ...</h4>
            </div>
          ) : (
            <div className="text-center py-5">
              <h4 style={{ color: "red" }}>{bookingMessage}</h4>
            </div>
          )}
        </Modal>
      </section>
    </>
  );
};

export default HotelPaymentTbo;
